export default __webpack_public_path__ + "static/media/secure.eaca2215.svg";